export const isContainsMatchBuilder = (searchText) => {
  const split = searchText.trim().toLowerCase().split(' ');
  const isMatchFunc = (optionLabel) => {
    const lowercaseLabel = optionLabel.toLowerCase();
    let allPartialsFound = true;
    split.forEach((partial) => {
      allPartialsFound =
        allPartialsFound && lowercaseLabel.indexOf(partial) > -1;
    });
    return allPartialsFound;
  };
  return (optionLabel) => isMatchFunc(optionLabel);
};

export const isStartsWithMatchBuilder = (searchText) => {
  const lowercaseSearchText = searchText.trim().toLowerCase();
  return (optionLabel) =>
    optionLabel.toLowerCase().indexOf(lowercaseSearchText) === 0;
};

const getMatchingOptions = (searchText, options, isMatch) => {
  return options.filter((option) => isMatch(option.label));
};

export const findMatches = (
  searchText,
  options,
  selections,
  isMatchFuncBuilder
) => {
  const updatedMatches = [];

  const isMatchFunc = isMatchFuncBuilder(searchText);

  const matchingOptions = getMatchingOptions(searchText, options, isMatchFunc);

  matchingOptions.forEach((option) => {
    const selected = (selections || []).find(
      (selection) => selection.value === option.value
    );
    updatedMatches.push({ ...option, selected });
  });

  return updatedMatches;
};

function removeUnselectedMatches(selections, unselectedMatches) {
  const updatedSelections = selections.filter(
    (selection) =>
      unselectedMatches.filter((match) => match.value === selection.value)
        .length === 0
  );

  return updatedSelections;
}

function addSelectedMatches(selectedMatches, updatedSelections) {
  selectedMatches.forEach((match) => {
    if (
      !updatedSelections.filter((selection) => selection.value === match.value)
        .length > 0
    ) {
      updatedSelections.push({ label: match.label, value: match.value });
    }
  });
}

function sortByLabel() {
  return (a, b) => (a.label > b.label ? 1 : -1);
}

export const applySelectedMatches = (selections, matches) => {
  if (matches === null || matches.length === 0) return selections;
  const unselectedMatches = matches.filter((match) => !match.selected);
  const selectedMatches = matches.filter((match) => match.selected);

  const updatedSelections = removeUnselectedMatches(
    selections,
    unselectedMatches
  );
  addSelectedMatches(selectedMatches, updatedSelections);

  return updatedSelections.sort(sortByLabel());
};
